import { BaseEntity } from ".";
import { IGet_corporations_corporation_id_wallets_division_journal_200_ok } from "../service/esiclient";
import moment from "moment";

export class CorporationWalletJournalEntity extends BaseEntity {
  constructor(id: number, props: any) {
    super(id, props);
    this._dataTypeName = "Corporation Division Journal";
  }

  async toJson(): Promise<Excel.EntityCellValue> {
    //This dataset is very basic
    const props: Partial<IGet_corporations_corporation_id_wallets_division_journal_200_ok> = this.props;
    var entity = await super.toJson();
    // Properties
    if (entity.properties) {
      // - Id
      if (props.date) {
        const date = moment(props.date);
        entity.properties["date"] = {
          type: Excel.CellValueType.formattedNumber,
          basicValue: date.unix() / 86400 + 25569,
          numberFormat: "[$-409]m/d/yy h:mm AM/PM;@",
        };
      }
      const numberOptions = { minimumFractionDigits: 2 };
      const priceVar = props.amount?.toLocaleString("en-GB", numberOptions);
      // The display for now is "amount ISK (description)"", not a lot of informative strings in this property
      entity.text = priceVar + " ISK (" + props.description?.toString() + ")";
      entity.properties["name"] = {
        type: Excel.CellValueType.string,
        basicValue: entity.text,
      };
    }
    // Layouts
    entity.layouts = {
      card: {
        title: { property: "name" },
      },
    };

    return entity;
  }
}
